import React from 'react'
import PropTypes from 'prop-types'
import LPFAQItems from './LPFAQItems'

import { Section, ContentContainer } from './styles'

export default function LPFAQSection({ sections }) {
  const displaySections = sections || [] // Get around builder error -- doesn't register defaultValue
  return (
    <ContentContainer>
      {displaySections.map((section, j) => {
        const { title, content } = section
        const displayContent = content || []
        return (
          <React.Fragment key={j}>
            {title && <Section>{title}</Section>}
            {displayContent.map((questionContent, i) => {
              const { question, answer, text, link, punctuation, placement } = questionContent
              return (
                <LPFAQItems
                  key={i + question}
                  question={question}
                  answer={answer}
                  text={text}
                  link={link}
                  punctuation={punctuation}
                  placement={placement}
                />
              )
            })}
          </React.Fragment>
        )
      })}
    </ContentContainer>
  )
}
LPFAQSection.propTypes = {
  sections: PropTypes.array,
}
